import React from 'react';
import { useProctor } from '../../context/ProctorContext';

export function StartOverlay() {
  const { setPhase, setStartTime } = useProctor();

  const handleStart = () => {
    setStartTime(Date.now());
    setPhase('calibrating');
  };

  return (
    <div className="start-overlay">
      <h2>Dr. Simon AI Proctoring Demo</h2>
      <p>
        멀티모달 시험감독 데모입니다.<br />
        카메라와 마이크 권한이 필요합니다.<br />
        WebEyeTracker + MediaPipe + 다중 센서 통합
      </p>
      <button className="start-btn" onClick={handleStart}>
        시작
      </button>
    </div>
  );
}
